var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTataLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94141 39.0723H15.4504V43.1832H11.575V53.063H5.94583V43.1832H1.94141V39.0723Z",
    fill: "#486AAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2931 44.7251L19.4489 53.063H14.043L19.3449 39.0723H25.2159L30.6456 53.063H25.1732L22.2931 44.7251Z",
    fill: "#486AAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3516 39.0723H42.8601V43.1832H38.9858V53.063H33.3569V43.1832H29.3516V39.0723Z",
    fill: "#486AAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7043 44.7251L46.8591 53.063H41.4531L46.7568 39.0723H52.6261L58.0539 53.063H52.5835L49.7043 44.7251Z",
    fill: "#486AAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9047 13.3743C49.4003 12.3824 48.7359 11.4317 47.9096 10.5402C46.0525 8.5358 43.4323 6.86788 40.3315 5.71751C37.2051 4.55823 33.6393 3.94482 30.0156 3.94482C26.392 3.94482 22.8261 4.55823 19.7014 5.71751C16.599 6.86801 13.9787 8.53593 12.1216 10.5402C11.2957 11.4316 10.6293 12.3836 10.125 13.376C14.1619 12.3998 21.0671 11.1109 27.4788 10.9747C28.0972 10.9614 28.5231 11.1595 28.8034 11.5148C29.145 11.9476 29.1193 13.4901 29.1109 14.1802L28.9287 32.0174C29.2898 32.0294 29.6526 32.0371 30.0156 32.0371C30.3818 32.0371 30.7466 32.0311 31.1076 32.0191L30.9254 14.1801C30.9159 13.4901 30.8895 11.9474 31.2322 11.5147C31.5133 11.1595 31.9376 10.9614 32.5559 10.9745C38.9649 11.1097 45.8686 12.3989 49.9047 13.3743Z",
    fill: "#486AAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7682 15.6939C44.8599 14.3582 40.9143 14.1112 37.0211 13.8951C33.6276 13.7065 33.5833 14.9183 33.922 17.234C33.9442 17.3753 33.9715 17.5535 34.0038 17.7566C35.1421 24.4985 36.5595 30.3002 36.8031 31.2849C45.0762 29.3938 51.0426 24.1506 51.0426 17.9913C51.0426 17.2157 50.9489 16.4473 50.7682 15.6939Z",
    fill: "#486AAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1129 17.234C26.452 14.9184 26.4085 13.7065 23.0154 13.8951C19.1209 14.1112 15.1743 14.358 9.26374 15.6947C9.0832 16.4481 8.98828 17.2155 8.98828 17.9911C8.98828 20.6532 10.0712 23.2292 12.1205 25.4423C13.9776 27.4467 16.5979 29.1146 19.7003 30.2658C20.8231 30.6815 22.0081 31.0222 23.2286 31.2948C23.4577 30.3723 24.9077 24.4499 26.0584 17.5874C26.0796 17.4559 26.0993 17.3345 26.1129 17.234Z",
    fill: "#486AAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTataLogo1);
export default __webpack_public_path__ + "static/media/Tata_logo 1.5984f3abe31ccbf3559dbae611a1de64.svg";
export { ForwardRef as ReactComponent };